// extracted by mini-css-extract-plugin
export var backButton = "_1b-1";
export var content = "_1b-d";
export var continueButton = "_1b-7";
export var continueHint = "_1b-8";
export var continueRow = "_1b-6";
export var leftInner = "_1b-0";
export var sidebarContent = "_1b-5";
export var skipButton = "_1b-c";
export var spacer = "_1b-2";
export var spin = "_1b-a";
export var spinner = "_1b-9";
export var spinnerOverlay = "_1b-b";
export var subtitle = "_1b-4";
export var title = "_1b-3";